(function(){
'use strict';
var D=window.MPB2B; if(!D)return;
var broot=document.getElementById('mpb'); if(!broot)return;
var esc=D.esc,ICON=D.ICON,CATS=D.CATS;
var S={step:1,type:null,format:null,pack:null,qty:1000,ings:{}};
var $=function(id){return document.getElementById(id);};
var val=function(id){var e=$(id);return e?e.value.trim():'';};
function optCard(l,ic,d,on){return '<button type="button" class="opt'+(on?' on':'')+'"><div class="oi">'+(ICON[ic]||'◆')+'</div><div class="ot">'+esc(l)+'</div>'+(d?'<div class="od">'+esc(d)+'</div>':'')+'</button>';}
function bindOpts(id,key,labels){var w=$(id);w.querySelectorAll('.opt').forEach(function(o,i){o.addEventListener('click',function(){w.querySelectorAll('.opt').forEach(function(x){x.classList.remove('on');});o.classList.add('on');S[key]=labels[i];sheet();});});}
$('mpb-type').innerHTML=D.TYPES.map(function(t){return optCard(t[0],t[1],t[2],false);}).join('');bindOpts('mpb-type','type',D.TYPES.map(function(t){return t[0];}));
$('mpb-format').innerHTML=D.FORMATS.map(function(f){return optCard(f[0],f[1],'',false);}).join('');bindOpts('mpb-format','format',D.FORMATS.map(function(f){return f[0];}));
$('mpb-pack').innerHTML=D.PACKS.map(function(p){return optCard(p[0],p[1],'',false);}).join('');bindOpts('mpb-pack','pack',D.PACKS.map(function(p){return p[0];}));
function renderIngs(){
 var w=$('mpb-ings');var cats=CATS[S.type]||CATS['Custom formula'];var std={};Object.keys(cats).forEach(function(c){cats[c].forEach(function(i){std[i]=1;});});
 var h='<div class="ctx">Ingredients for <b>'+esc(S.type||'your product')+'</b> · tap to add, set the dose in the sheet →</div>';
 Object.keys(cats).forEach(function(c){h+='<div class="catrow"><h4>'+esc(c)+'</h4><div class="chips">'+cats[c].map(function(x){return '<button type="button" class="chip'+(S.ings[x]!==undefined?' on':'')+'" data-ing="'+esc(x)+'">'+esc(x)+'</button>';}).join('')+'</div></div>';});
 var extras=Object.keys(S.ings).filter(function(k){return !std[k];});
 h+='<div class="catrow addrow"><h4>Add your own ingredient</h4><div class="addwrap"><input id="mpb-cing" placeholder="Ingredient name (e.g. Cordyceps, ORS)"><input id="mpb-cdose" class="dose" placeholder="Dose (optional)"><button type="button" class="btn add" id="mpb-add">Add</button></div>';
 if(extras.length)h+='<div class="chips" style="margin-top:11px">'+extras.map(function(x){return '<button type="button" class="chip on custom" data-ing="'+esc(x)+'">'+esc(x)+' ✕</button>';}).join('')+'</div>';
 h+='</div>';w.innerHTML=h;
 w.querySelectorAll('.chip[data-ing]:not(.custom)').forEach(function(ch){ch.addEventListener('click',function(){var n=ch.getAttribute('data-ing');if(S.ings[n]!==undefined){delete S.ings[n];ch.classList.remove('on');}else{S.ings[n]='';ch.classList.add('on');}sheet();});});
 w.querySelectorAll('.chip.custom').forEach(function(ch){ch.addEventListener('click',function(){delete S.ings[ch.getAttribute('data-ing')];renderIngs();sheet();});});
 var add=function(){var nm=$('mpb-cing').value.trim();if(!nm)return;S.ings[nm]=$('mpb-cdose').value.trim();renderIngs();sheet();var ci=$('mpb-cing');if(ci)ci.focus();};
 $('mpb-add').addEventListener('click',add);
 ['mpb-cing','mpb-cdose'].forEach(function(id){$(id).addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();add();}});});
}
var qr=$('mpb-qty'),qv=$('mpb-qtyval');
function setRange(){var p=(qr.value-qr.min)/(qr.max-qr.min)*100;qr.style.setProperty('--fill',p+'%');qv.textContent=(+qr.value).toLocaleString('en-IN')+' units';S.qty=+qr.value;sheet();}
qr.addEventListener('input',setRange);setRange();
function sheet(){
 $('mpb-sType').textContent=S.type||'—';$('mpb-sFormat').textContent=S.format||'—';$('mpb-sPack').textContent=S.pack||'—';$('mpb-sQty').textContent=S.qty?S.qty.toLocaleString('en-IN')+' units':'—';
 var keys=Object.keys(S.ings);$('mpb-ingCount').textContent=keys.length;$('mpb-sEmpty').style.display=keys.length?'none':'block';
 $('mpb-sIngs').innerHTML=keys.map(function(k){return '<li><span class="inm" title="'+esc(k)+'">'+esc(k)+'</span><input class="dosein" data-k="'+esc(k)+'" value="'+esc(S.ings[k]||'')+'" placeholder="dose"></li>';}).join('');
 document.querySelectorAll('#mpb-sIngs .dosein').forEach(function(inp){inp.addEventListener('input',function(){S.ings[inp.getAttribute('data-k')]=inp.value;});});
}
function renderPips(){$('mpb-pips').innerHTML=D.PIPS.map(function(p,i){var n=i+1,cls=S.step===n?'on':(S.step>n?'done':'');return '<div class="pip '+cls+'"><span class="num">'+(S.step>n?'✓':n)+'</span>'+p+'</div>';}).join('');}
var back=$('mpb-back'),next=$('mpb-next');
function showStep(){
 broot.querySelectorAll('.step').forEach(function(s){s.classList.toggle('on',+s.getAttribute('data-step')===S.step);});
 renderPips(); if(S.step===3)renderIngs();
 back.style.visibility=(S.step>1&&S.step<6)?'visible':'hidden';
 if(S.step===5)next.textContent='Submit formulation ✓';
 else if(S.step<6){next.textContent='Continue →';next.style.visibility='visible';}
 else{next.style.visibility='hidden';back.style.visibility='hidden';}
}
function bump(m){next.textContent=m;next.style.background='var(--amber)';setTimeout(function(){next.textContent=(S.step===5?'Submit formulation ✓':'Continue →');next.style.background='var(--citrus)';},1600);}

function specText(ref){
 var keys=Object.keys(S.ings);
 var lines=[];
 lines.push('NEW FORMULATION ENQUIRY');
 lines.push('Reference: '+ref);
 lines.push('');
 lines.push('--- PRODUCT SPEC ---');
 lines.push('Product category: '+(S.type||'not specified'));
 lines.push('Format: '+(S.format||'not specified'));
 lines.push('Packaging: '+(S.pack||'not specified'));
 lines.push('Unit size: '+(val('mpb-unit')||'not specified'));
 lines.push('Brand name: '+(val('mpb-brand')||'not specified'));
 lines.push('First batch quantity: '+S.qty.toLocaleString('en-IN')+' units');
 lines.push('');
 lines.push('--- INGREDIENT DECK ('+keys.length+') ---');
 if(keys.length){ keys.forEach(function(k){ lines.push('- '+k+(S.ings[k]?' — '+S.ings[k]:'')); }); }
 else { lines.push('(none selected)'); }
 lines.push('');
 lines.push('--- CONTACT ---');
 lines.push('Name: '+(val('mpb-name')||'-'));
 lines.push('Company: '+(val('mpb-co')||'-'));
 lines.push('Email: '+(val('mpb-email')||'-'));
 lines.push('Phone/WhatsApp: '+(val('mpb-phone')||'-'));
 lines.push('City: '+(val('mpb-city')||'-'));
 lines.push('Notes: '+(val('mpb-note')||'-'));
 lines.push('');
 lines.push('Submitted from '+window.location.href);
 return lines.join('\n');
}

function finish(ref, ok, body){
 var r=$('mpb-ref'); if(r) r.textContent='REF · '+ref;
 var done=broot.querySelector('.step[data-step="6"] .done');
 if(done && !done.querySelector('.mpb-wa')){
   var wrap=document.createElement('div');
   wrap.style.marginTop='16px';
   var short='Hi MetaPro, I just submitted formulation '+ref+'. Please share feasibility and pricing.';
   wrap.innerHTML='<a class="mpb-wa" href="'+window.MPLead.waLink(ok?short:body)+'" target="_blank" rel="noopener" '+
     'style="display:inline-flex;align-items:center;gap:.5rem;background:#25D366;color:#fff;padding:.85rem 1.35rem;border-radius:999px;font-weight:700;text-decoration:none">'+
     'Send on WhatsApp too</a>'+
     '<div style="margin-top:10px;font-size:.9rem;opacity:.85">'+
     (ok ? 'We have your spec by email. Sending it on WhatsApp gets you a faster reply.'
         : '<b>We could not send this automatically.</b> Please tap WhatsApp above or call +91 98151 18798 so your spec reaches us.')+
     '</div>';
   done.appendChild(wrap);
 }
 S.step=6; showStep();
}

next.addEventListener('click',function(){
 if(S.step===1&&!S.type)return bump('Pick a category');
 if(S.step===2&&!S.format)return bump('Choose a format');
 if(S.step===5){
   var name=val('mpb-name'), email=val('mpb-email'), phone=val('mpb-phone');
   if(!name) return bump('Add your name');
   if(!email && !phone) return bump('Add email or phone');
   if(email && email.indexOf('@')<1) return bump('Check the email');
   var ref=window.MPLead.ref('MPL');
   var body=specText(ref);
   next.disabled=true; next.textContent='Sending…';
   window.MPLead.send({name:name,email:email,phone:phone,body:body}).then(function(ok){
     next.disabled=false;
     finish(ref, ok, body);
   });
   return;
 }
 S.step++;showStep();
});
back.addEventListener('click',function(){S.step--;showStep();});
showStep();sheet();
})();
